export enum Scope {
  GLOBAL = 'GLOBAL',
  ORGANIZATION = 'ORGANIZATION',
  PROJECT = 'PROJECT',
}

export const SYSTEM_ADMIN = 'ROLE_SYS_ADMIN';
export const ORGANIZATION_ADMIN = 'ROLE_ORGANIZATION_ADMIN';
export const PROJECT_ADMIN = 'ROLE_PROJECT_ADMIN';
export const PROJECT_MONITOR = 'ROLE_PROJECT_MONITOR';
